// import node module libraries
import React, { Fragment } from 'react';
import { Outlet } from 'react-router-dom';

// import layouts
import NavbarHaeppyapp from 'layouts/marketing/navbars/NavbarHaeppyapp';
import FooterHaeppyapp from 'layouts/marketing/footers/FooterHaeppyapp';

const DefaultLayout = (props) => {
	return (
		<Fragment>
			<main>
				{props.children}
				<Outlet />
			</main>
			<FooterHaeppyapp />
		</Fragment>
	);
};

export default DefaultLayout;
